import { AlertTriangle, Printer, X } from "lucide-react";

export default function PrintConfirmModal({ job, onClose }) {
  if (!job) return null;
  const { count, pages, overflow } = job;
  const go = () => { job.print(); onClose(); };
  const cancel = () => { job.cancel(); onClose(); };
  return (
    <div className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center bg-ink/40 p-4" data-testid="print-confirm-modal" onClick={cancel}>
      <div className="w-full max-w-sm rounded-2xl bg-white p-5 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3">
          <h3 className="text-sm font-medium text-ink inline-flex items-center gap-2"><Printer size={15} className="text-maroon" /> Print invoices</h3>
          <button type="button" onClick={cancel} aria-label="Close" data-testid="print-confirm-close" className="text-muted2 hover:text-maroon"><X size={16} /></button>
        </div>
        <p className="mt-3 text-sm text-ink" data-testid="print-confirm-summary">
          {count} invoice{count === 1 ? "" : "s"} selected · {pages} A4 page{pages === 1 ? "" : "s"} · Portrait · 4 per page
        </p>
        {overflow.length > 0 && (
          <div className="mt-3 rounded-xl border border-[#8A2A2A]/40 bg-[#F5D3D3] px-3 py-2 text-xs text-[#5A1A1A]" data-testid="print-overflow-warning">
            <p className="inline-flex items-center gap-1.5 font-semibold"><AlertTriangle size={13} /> Too much text to fit legibly</p>
            <p className="mt-1">Invoice{overflow.length === 1 ? "" : "s"} {overflow.join(", ")} may be clipped at the smallest readable size. Shorten the notes or print fewer invoices together.</p>
          </div>
        )}
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" onClick={cancel} data-testid="print-confirm-cancel" className="btn-outline-maroon !py-2 !px-4 !text-xs">Cancel</button>
          <button type="button" onClick={go} data-testid="print-confirm-print" className="rounded-full bg-maroon px-4 py-2 text-xs font-medium text-ivory hover:bg-maroon-hover inline-flex items-center gap-1.5">
            <Printer size={13} /> {overflow.length ? "Print anyway" : "Print"}
          </button>
        </div>
      </div>
    </div>
  );
}
